module.exports = __webpack_public_path__ + "static/img/6.63a41b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/6.png
// module id = a+e/
// module chunks = 0